import {
	clickerCommand,
	isEditableTarget,
	KeyPress,
} from 'features/script/clicker'
import type { PresenterCommand } from './presenter-messages'

/** `B` or `.` blacks the projector, as in presentation software. */
export const isBlackScreenKey = (press: KeyPress): boolean =>
	(press.key === 'b' || press.key === 'B' || press.key === '.') &&
	!press.repeat &&
	!press.ctrlKey &&
	!press.metaKey &&
	!press.altKey &&
	!isEditableTarget(press.target)

/**
 * What a key pressed in the presentation window asks the console to do: the
 * clicker's Next and Prev, or black screen. The console does it - the
 * presentation window never acts on the session itself.
 */
export const presenterKeyCommand = (
	press: KeyPress,
	at: { pageFocused: boolean }
): PresenterCommand | undefined =>
	clickerCommand(press, at) ?? (isBlackScreenKey(press) ? 'black' : undefined)
